<template>
  <div class="consult-index-personer-Info">
    <div class="info-top">
      <img
        :src="basicInfo.avatar | imgZip(140)"
        alt=""
        class="top-avatar"
        @click="showImgViewer"
      />
      <div
        class="top-basic"
        :class="{ common: isConsultTeacher && isQingtingTeacher }"
      >
        <template v-if="isConsultTeacher && isQingtingTeacher">
          <div class="top-basic-t">
            <div class="name-and-zxteacher">
              <span class="name">{{ basicInfo.nickname }}</span>
              <city />
            </div>
            <div class="view-label">
              <span
                v-if="zxProTeacher"
                @click="openStandardPopup"
                class="zxteacher"
              >
                <i></i>
                {{ zxProTeacher.name }}</span
              >
              <img
                v-if="isQingtingTeacher && qingsuLevel"
                class="qingsu-level"
                @click="onClickQingsuLevel"
                :src="
                  require(`../../../../images/platform/homepage/icon-level-${qingsuLevel}.png`)
                "
              />
            </div>
          </div>
          <div class="business-card" @click="handleClickNamecard">
            <i></i>
            <span>名片</span>
          </div>
        </template>
        <template v-else>
          <div class="top-basic-t">
            <div class="name-and-zxteacher">
              <span class="name">{{ basicInfo.nickname }}</span>
              <span
                v-if="zxProTeacher"
                @click="openStandardPopup"
                class="zxteacher"
              >
                <i></i>
                {{ zxProTeacher.name }}</span
              >
              <img
                v-else-if="isQingtingTeacher && qingsuLevel"
                class="qingsu-level"
                @click="onClickQingsuLevel"
                :src="
                  require(`../../../../images/platform/homepage/icon-level-${qingsuLevel}.png`)
                "
              />
            </div>
            <div
              class="business-card"
              @click="handleClickNamecard"
              :class="{ 'qingsu-own': isQingtingTeacher && !isConsultTeacher }"
            >
              <i></i>
              <span>名片</span>
            </div>
          </div>
          <div class="city-wrap">
            <city v-if="isConsultTeacher" />
          </div>
        </template>
      </div>
    </div>
    <ul class="tags" v-if="tagList.length || qingsuLabels.length">
      <li
        v-for="tag in tagList"
        :key="tag.title"
        :style="{ 'paddin-left': !tag.icon ? '0.12rem' : '' }"
        @click.stop="onTagClick(tag, 'consult')"
        class="tags-item"
      >
        <img
          v-if="tag.icon"
          :src="tag.icon"
          alt=""
          :style="{ 'margin-top': isPc ? '-0.004rem' : '0' }"
        />
        <span class="content">{{ tag.title }}</span>
      </li>
      <li
        v-for="(label, index) in qingsuLabels"
        :key="index"
        @click.stop="onTagClick(label, 'qingsu')"
        class="qingsu-tag"
      >
        <img
          v-if="label.type === 'icon'"
          :src="
            require(`../../../../images/platform/homepage/icon-${label.name}.png`)
          "
        />
        <div v-else :class="label.type">
          {{ label.name }}
        </div>
      </li>
    </ul>
    <yxlMore
      :lineClamp="2"
      :info="personalDesc"
      @hook:updated="yxlMoreUpdated"
      @setShowAllCallback="setShowAllCallback"
      class="consult-more-text"
    />
    <div class="num-block-list-wrap">
      <ul class="num-block-list" v-if="isConsultTeacher">
        <li class="block" v-for="(item, index) in blocks" :key="index">
          <div class="block-top DharmaTypeBebasKai">
            <p v-html="item.label"></p>
          </div>
          <div class="block-bottom" v-html="item.name"></div>
        </li>
      </ul>
      <ul class="num-block-list" v-if="isQingtingTeacher">
        <li class="block" v-for="(item, index) in qingsuBlock" :key="index">
          <div class="block-top DharmaTypeBebasKai">
            <p v-html="item.label"></p>
          </div>
          <div class="block-bottom" v-html="item.name"></div>
        </li>
      </ul>
    </div>
    <tagDetailPopup
      :tagDetail="tagDetail"
      @close="tagDetail = null"
    ></tagDetailPopup>
    <!-- 咨询师入驻标准弹窗 -->
    <consultStandardPopup
      :show.sync="isShowStandardPopup"
    ></consultStandardPopup>
    <!-- 倾听师等级弹窗 -->
    <qingsuLevelModel :show.sync="showQingsuLevelModel" />
    <!-- 倾听师标签弹窗 -->
    <qingsuTagModel :show.sync="showQingsuTagModel" :tag="qingsuTag" />
  </div>
</template>
<script>
import tagDetailPopup from '../consultTeacher/tagDetailPopup.vue'
import yxlMore from 'component/common/yxlMore.vue'
import expertXltMixin from 'mixins/xlt/expertXltMixin.js'
import { genCustomFonts, userInfoShowAllStat } from 'utils/homepageUtil.js'
import consultStandardPopup from '../consultTeacher/consultStandardPopup.vue'
import qingsuLevelModel from 'component/platform/homepage/qingsuTeacher/qingsuLevelModel.vue'
import qingsuTagModel from 'component/platform/homepage/qingsuTeacher/qingsuTagModel.vue'
import { mapGetters } from 'vuex'
import { getPlatform } from 'app/frontend-lib/tools/getPlatform'
import city from 'component/platform/homepage/common/city.vue'

export default {
  mixins: [expertXltMixin],
  components: {
    tagDetailPopup,
    yxlMore,
    consultStandardPopup,
    qingsuLevelModel,
    qingsuTagModel,
    city
  },
  data() {
    return {
      tagDetail: null,
      showNavigationSelect: false,
      isShowStandardPopup: false,
      showQingsuLevelModel: false,
      showQingsuTagModel: false,
      qingsuTag: '',
      isPc: false
    }
  },
  mounted() {
    this.isPc = getPlatform().isPc
  },
  methods: {
    yxlMoreUpdated() {
      this.$emit('updated')
    },
    setShowAllCallback(showall) {
      if (this.isQingtingTeacher && !this.isConsultTeacher) {
        this.$trackEvent('newprofilepages_listener_selfintroduction_all')
        return
      }
      userInfoShowAllStat.call(this, showall)
    },
    onTagClick(tag, type) {
      if (type === 'consult') {
        this.$trackEvent('newprofilepages_teachertags', {})
        this.tagDetail = tag
      } else {
        this.$trackEvent('newprofilepages_listenertag', {
          tag_type: '推荐标签'
        })
        this.qingsuTag = tag.label
        this.showQingsuTagModel = true
      }
    },
    handleClickNamecard() {
      this.$trackEvent('newprofilepages_namecard', {})
      this.$emit('openSharePosterModal')
    },
    showImgViewer() {
      this.$trackEvent('newprofilepages_avatar', {})
      this.$emit('showImgViewer')
    },
    openStandardPopup() {
      this.$trackEvent('newprofilepages_psychologicalcounselor_label', {})
      this.isShowStandardPopup = true
    },
    onClickQingsuLevel() {
      this.$trackEvent('newprofilepages_listenertag', {
        tag_type: '等级标签'
      })
      this.showQingsuLevelModel = true
    }
  },
  computed: {
    ...mapGetters({
      isConsultTeacher: 'homepage/isConsultTeacher',
      isQingtingTeacher: 'homepage/isQingtingTeacher'
    }),
    basicInfo() {
      return this.$store.state.homepage.basicInfo || {}
    },
    // 是否专业咨询师
    zxProTeacher() {
      if (!this.isConsultTeacher) {
        return false
      }
      let { identities } = this.basicInfo
      identities = Array.isArray(identities) ? identities : []
      return identities.find(item => item.business === 'zixun_pro_teacher')
    },
    tagList() {
      const { consult_identities } = this.basicInfo
      let arr = Array.isArray(consult_identities) ? consult_identities : []
      return arr.slice(0, 3)
    },
    blocks() {
      const { achieve_count = {} } = this.basicInfo
      const {
        consult_num,
        service_duration,
        experience_year = {},
        // praise_num,
        fans_num
      } = achieve_count
      const { year, month } = experience_year

      const list = [
        {
          name: `咨询人次`,
          get label() {
            return (
              genCustomFonts(consult_num) + `<span class="bb-text">人次</span>`
            )
          }
        },
        {
          name: `服务时长`,
          get label() {
            return (
              genCustomFonts(service_duration) +
              `<span class="bb-text">小时</span>`
            )
          }
        },
        {
          name: `从业年限`,
          get label() {
            const m = genCustomFonts(month)
            const y = genCustomFonts(year)
            const arr = [`${m}<span class="bb-text">月</span>`]
            if (+year > 0) {
              arr.unshift(`${y}<span class="bb-text">年</span>`)
            }
            return arr.join('')
          },
          hide: !year && !month
        },
        // {
        //   name: `获赞`,
        //   get label() {
        //     return (
        //       genCustomFonts(praise_num) + `<span class="bb-text">次</span>`
        //     )
        //   },
        //   hide: +praise_num < 50 || this.mixinShowStudioInfo
        // },
        {
          name: `粉丝`,
          get label() {
            return genCustomFonts(fans_num) + `<span class="bb-text">人</span>`
          },
          hide: +fans_num < 20 || this.mixinShowStudioInfo
        }
      ]
      return list.filter(item => !item.hide)
    },
    qingsuBlock() {
      const { qing_info = {} } = this.basicInfo
      const { qingnum, service_duration, goodrate, quick_rate } = qing_info
      return [
        {
          name: `倾诉人数`,
          get label() {
            return genCustomFonts(qingnum) + `<span class="bb-text">人</span>`
          }
        },
        {
          name: `倾诉时长`,
          get label() {
            return (
              genCustomFonts(service_duration) +
              `<span class="bb-text">小时</span>`
            )
          }
        },
        {
          name: `好评率`,
          get label() {
            const rate = Number(goodrate || 0).toFixed(1)
            return genCustomFonts(+rate) + `<span class="bb-text">%</span>`
          }
        },
        {
          name: `快速响应率`,
          get label() {
            return genCustomFonts(quick_rate) + `<span class="bb-text">%</span>`
          }
        }
      ]
    },
    qingsuBaseInfo() {
      return this.basicInfo.qing_info || {}
    },
    qingsuLevel() {
      const { grade } = this.qingsuBaseInfo
      return (grade && grade.grade_level) || ''
    },
    qingsuLabels() {
      // 外部渠道不显示
      if (this.isOuterChannel) {
        return []
      }
      let likeLabels = this.qingsuBaseInfo.like_labels
      if (!this.isQingtingTeacher || !likeLabels) {
        return []
      }
      likeLabels = likeLabels.slice(0, 3)
      return likeLabels.map(label => {
        let result = null
        if (label.includes('已入驻') || label.includes('咨询师资质')) {
          result = {
            type: 'tag',
            name: label
          }
        } else {
          switch (label) {
            case '热门TOP30':
              result = {
                type: 'icon',
                name: 'qingsu-top'
              }
              break
            case '近期入驻TOP50':
              result = {
                type: 'icon',
                name: 'new-join'
              }
              break
            case '好评TOP50':
              result = {
                type: 'icon',
                name: 'good-rate'
              }
              break
            case '人气飙升TOP50':
              result = {
                type: 'icon',
                name: 'qingsu-hot'
              }
              break
            case '快速响应':
              result = {
                type: 'icon',
                name: 'quick-reply'
              }
              break
            case '12.12嘉年华':
              result = {
                type: 'icon',
                name: 'anniversary'
              }
              break
            default:
              result = {
                type: 'text',
                name: label
              }
          }
        }
        result.label = label
        return result
      })
    },
    personalDesc() {
      return this.isConsultTeacher
        ? this.basicInfo.honor
        : this.basicInfo.brief || 'ta还没填写简介呢。'
    },
    isOuterChannel() {
      const { cid = '', cp_channel_id = '' } = this.$route.query
      return cid || cp_channel_id
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~lib/scss/functions.scss';
.consult-index-personer-Info {
  padding: 0 32px;
  margin-top: -74px;
  .info-top {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    .top-avatar {
      width: 140px;
      height: 140px;
      border-radius: 50%;
      object-fit: cover;
      border: 1px solid #ffffff;
      z-index: 2;
    }
    .top-basic {
      width: calc(10rem - 224px);
      &.common {
        display: flex;
        .top-basic-t {
          flex-direction: column;
          justify-content: flex-end;
          align-items: flex-start;
        }
        .name-and-zxteacher {
          align-items: center;
        }
        .name {
          max-width: 200px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .zxteacher {
          margin-left: 0;
        }
        .business-card {
          margin-top: 7px;
        }
        /deep/ .city {
          margin-left: 16px;
          margin-top: 0;
        }
      }
    }
    .top-basic-t {
      display: flex;
      align-items: flex-end;
      .name-and-zxteacher {
        display: flex;
        align-items: flex-end;
        .qingsu-level {
          margin-left: 16px;
        }
      }
      .name {
        font-size: 38px;
        line-height: 42px;
        font-weight: 600;
        color: #21252d;
        max-width: 200px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .zxteacher {
        display: flex;
        align-items: center;
        height: 36px;
        background: #fcf0dc linear-gradient(180deg, #fef5e6 0%, #f5e6b2 100%);
        border-radius: 17px;
        padding-right: 12px;
        margin-left: 16px;
        font-size: 20px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #a2762e;
        i {
          width: 30px;
          height: 30px;
          margin: 0 5px;
          background: url('~images/platform/homepage/zxteacher-tag-icon.png')
            center/30px 30px no-repeat;
        }
      }
    }
    .business-card {
      display: flex;
      justify-content: space-evenly;
      align-items: center;
      width: 92px;
      height: 42px;
      border-radius: 32px;
      border: 1px solid #6982fa;
      margin-left: auto;
      &.qingsu-own {
        border: 1px solid #ff745b;
        span {
          color: #ff745b;
        }
        i {
          background: url('~images/platform/homepage/icon-qingsu-qr.png')
            no-repeat center/100%;
        }
      }
      i {
        display: inline-block;
        width: 20px;
        height: 20px;
        background: url('~images/platform/homepage/card-2.png') no-repeat;
        background-size: 100%;
      }
      span {
        font-size: 20px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #6982fa;
        line-height: 42px;
      }
    }
    .view-label {
      display: flex;
      align-items: flex-end;
      height: 36px;
      margin-top: 13px;
    }
    .qingsu-level {
      width: 152px;
      height: 36px;
      &:not(:first-child) {
        margin-left: 10px;
      }
    }
    .city-wrap {
      margin-top: 12px;
      height: 28px;
    }
  }
  .tags {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    margin: 14px 0 0;
    li {
      margin-top: 16px;
    }
    &-item {
      height: 30px;
      background: #ffffff;
      border-radius: 6px;
      border: 0.013334rem solid #6982fa;
      padding-right: 9px;
      font-size: 22px;
      color: #6982fa;
      display: flex;
      align-items: center;
      justify-content: center;
      &:not(:nth-last-child(1)) {
        margin-right: 10px;
      }
      img {
        width: 30px;
        height: 30px;
        background: #6982fa;
        border-radius: 6px 0px 0px 6px;
        margin-left: -0.013334rem;
        margin-right: 8px;
        padding: 7px;
        box-sizing: border-box;
      }
    }
  }
  .qingsu-tag {
    font-size: 22px;
    color: #ffa202;
    border-radius: 6px;
    background: transparent;
    &:not(:last-child) {
      margin-right: 20px;
    }
    img {
      height: 30px;
      width: auto;
    }
    .tag,
    .text {
      display: flex;
      align-items: center;
      padding: 0 8px;
      height: 30px;
      border: 0.013334rem solid #ffa202;
      font-size: 22px;
      border-radius: 6px;
    }
  }
  .consult-more-text {
    margin-top: 30px;
  }
  .yxl-more {
    font-size: 24px;
    color: #6c798c;
  }
  .num-block-list-wrap {
    width: 686px;
    padding: 30px 0;
    background: #ffffff;
    box-shadow: 0px 0px 40px 0px #ebefff;
    border-radius: 30px;
    margin: 40px 0;
  }
  .num-block-list {
    display: flex;
    align-items: center;
    &:not(:first-child) {
      margin-top: 40px;
    }
    .block {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      flex: 1;
      position: relative;
      .block-top {
        font-size: 34px;
        font-family: BebasKai;
        font-weight: 400;
        color: #21252d;
        margin-bottom: 16px;
        height: 34px;
        p {
          display: flex;
          align-items: baseline;
        }
      }
      .block-bottom {
        font-size: 24px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #9da3ac;
        line-height: 24px;
      }
      &:not(:last-child)::after {
        content: '';
        width: 1px;
        height: 24px;
        background-color: #eaeaea;
        position: absolute;
        bottom: 6px;
        right: 0;
      }
    }
    ::v-deep .bb-num {
      font-size: 38px;
      line-height: 34px;
    }
    ::v-deep .bb-text {
      font-size: 20px;
      font-family: PingFangSC-Regular, PingFang SC;
      line-height: 20px;
      margin: 0 2px;
    }
  }
}
</style>
